module.exports = __webpack_public_path__ + "static/media/Andre 1.1a1288eb.svg";